export default function () {
  return function (input) {
    if (input) {
      path = input.replace("/en/", "");
      path = path.replace(".php", "");
      if (path == "") {
        return "main";
      } else {
        return path;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/eshop/Filters/page.js